import request from '@/utils/request'

export function getProcessList(params) {
	return request.get('audit/plan/list', {
		params
	})
}

export function getProcessDetail(params) {
	return request.get('audit/plan/detail', {
		params
	})
}

export function getProcessCategory(params) {
	return request.get('audit/category', {
		params
	})
}

export function processSave(data) {
	return request.post('audit/plan/save', data)
}

export function processStorage(data) {
	return request.post('audit/plan/storage', data)
}